import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { find, map } from 'lodash'
import PropTypes from 'prop-types'

import { PUBLIC_URL } from '../../common/constants'

import PaintworkList from './common/PaintworkList'
import PaintworkMesh from './common/PaintworkMesh'

function BodyPaintwork({ digitalCertificate }) {
  const { bodyConditions } = digitalCertificate
  const { t } = useTranslation()

  const elementsIconsCoords = [
    { bodyElementId: 1, coords: [65, 137] },
    { bodyElementId: 2, coords: [52, 30] },
    { bodyElementId: 3, coords: [302, 48] },
    { bodyElementId: 4, coords: [52, 247] },
    { bodyElementId: 5, coords: [302, 227] },
    { bodyElementId: 6, coords: [165, 38] },
    { bodyElementId: 7, coords: [240, 38] },
    { bodyElementId: 8, coords: [165, 238] },
    { bodyElementId: 9, coords: [240, 238] },
    { bodyElementId: 10, coords: [318, 137] },
    { bodyElementId: 11, coords: [219, 132] },
    { bodyElementId: 12, coords: [0, 137] },
    { bodyElementId: 13, coords: [370, 137] },
    { bodyElementId: 14, coords: [133, 140] },
    { bodyElementId: 15, coords: [301, 140] },
    { bodyElementId: 16, coords: [184, 74] },
    { bodyElementId: 17, coords: [238, 74] },
    { bodyElementId: 18, coords: [184, 202] },
    { bodyElementId: 19, coords: [233, 202] },
    { bodyElementId: 20, coords: [140, 56] },
    { bodyElementId: 21, coords: [140, 220] },
    { bodyElementId: 22, coords: [195, 71] },
    { bodyElementId: 23, coords: [195, 204] },
    { bodyElementId: 24, coords: [215, 10] },
    { bodyElementId: 25, coords: [215, 266] },
  ]
  const bodyConditionsWithCoords = map(bodyConditions, (elem) => {
    const item = find(elementsIconsCoords, {
      bodyElementId: elem.bodyElementId,
    })
    if (item) {
      const mainDamage = find(elem.BodyPaintwork, { isMain: true }) || false
      return {
        ...elem,
        coords: item.coords,
        mainDamage,
      }
    }
    return elem
  })

  return (
    <Grid container spacing={3}>
      <Grid item xs={5}>
        <Typography variant="h4">{t('bodyCondition.paintwork')}</Typography>
        <PaintworkList
          items={[
            { title: '50-150μm', subtitle: 'Lakier fabryczny' },
            { title: '151-200μm', subtitle: 'Lakierowanie renowacyjne' },
            {
              title: '200-300μm',
              subtitle: 'Naprawa i lakierowanie renowacyjne',
            },
            {
              title: '300-600μm',
              subtitle: 'Naprawa blacharska i lakierowanie',
            },
            {
              title: '>600μm',
              subtitle: 'Naprawa blacharska i lakierowanie',
            },
          ]}
        />
      </Grid>
      <Grid item xs={7}>
        <PaintworkMesh
          conditions={bodyConditionsWithCoords}
          mesh={`${PUBLIC_URL}/assets/images/car_body_mesh.png`}
          prefix="body"
        />
      </Grid>
    </Grid>
  )
}

BodyPaintwork.propTypes = {
  digitalCertificate: PropTypes.object,
}
BodyPaintwork.defaultProps = {
  digitalCertificate: {},
}

export default BodyPaintwork
